import { render } from "./currency.vue?vue&type=template&id=47e72d4a&ts=true"
import script from "./currency.ts?vue&type=script&lang=ts&external"
export * from "./currency.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__